import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import './styles/index.css';
import AssetWrapper from './scenes/assets';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import * as serviceWorker from './serviceWorker';
import ContextProvider from './context'
import './i18n';
import { Route } from 'react-router-dom';
import { Switch } from 'react-router-dom';
import CIAMWrapper from './scenes/assets/CIMAWrapper';

ReactDOM.render(
    // <ContextProvider>

    //     <Router>
    //         <Suspense fallback="loading">
    //             <Route path="/donation">
    //                 <AssetWrapper />
    //             </Route>
    //             <Route path='/ciam'>
    //                 <CIAMWrapper></CIAMWrapper>
    //             </Route>
    //         </Suspense>
    //     </Router>
    // </ContextProvider>, document.getElementById('root'));

<ContextProvider>
    <Router basename={ '/donation/' }>

        <Suspense fallback="loading">
            <AssetWrapper />
        </Suspense>
    </Router>
</ContextProvider>, document.getElementById('root'));

//@todo         AssetWrapper


//"proxy":"http://128.199.67.222:8081/ads/"
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
